module.exports = __webpack_public_path__ + "media/images/adwords_logo-5c8076e55d18f0544746c4f140086fbe.png";